import ActionLink from 'shared/components/links/ActionLink';
import {observer} from 'mobx-react';
import { observable, action, makeObservable } from 'mobx';

const Banner = observer(({children, uiState, dismissable = true}) => {
  if (uiState.hidden) return null;

  return (
    <div className='Container center bg-meadow white h4 box-shadow-1 rounded'>
      <div className='block mx-auto py2'>
        {children}
        {dismissable && <ActionLink className='white' onClick={() => uiState.dismissBanner()}>
          <i className='material-symbols-solid h2 align-middle right'>{'close'}</i>
        </ActionLink>}
      </div>
    </div>
  );
});

class BannerState {
  hidden;

  constructor() {
    makeObservable(this, {
      hidden: observable,
      dismissBanner: action
    });
  }

  dismissBanner() {
    this.hidden = true;
  }
}

const BannerWithState = ({children, ...rest}) => {
  const uiState = new BannerState();
  return <Banner uiState={uiState} {...rest}>
    {children}
  </Banner>;
};

export default BannerWithState;
